<div class="content-title-container" *ngIf="title">
  <p class="content-title">{{ title }}</p>
</div>
<div class="page-block-content">
  <ng-content></ng-content>
</div>
